import React from 'react';
import TranslatedText from '../../../../components/atoms/translated_text';
import BaseModal from '../../../../components/molecules/base_modal';
import { ModalIDs } from '../../../../redux/reducers/gl_modal_reducer/types';

export default function NotificationViewModal() {
  return (
    <BaseModal
      modalID={ModalIDs.MODAL_NOTIFICATION_VIEW}
      renderHeader={({ header, body }: IModalProps) => (
        <NotificationViewHeader header={header} body={body} />
      )}
      renderContent={({ header, body }: IModalProps) => (
        <React.Fragment>
          <NotificationViewBody header={header} body={body} />
        </React.Fragment>
      )}
    />
  );
}

interface IModalProps {
  header: string;
  body: string;
}

const NotificationViewHeader = ({ header, body }: IModalProps) => {
  return <TranslatedText defaultText={header} />;
};

const NotificationViewBody = ({ header, body }: IModalProps) => {
  return <div dangerouslySetInnerHTML={{ __html: body }} />;
};
